<script lang="ts">import { getCartCount } from '../../../../../js-v2/stores/user-state-stores';
const { statusZero = '{count} items', statusOne = '{count} item', statusMany = '{count} items', slideInFrom = 'top', } = $props();
const countStore = getCartCount();
function getStatus(count) {
    switch (count) {
        case 0: {
            return statusZero.replace(/{count}/, count?.toString());
        }
        case 1: {
            return statusOne.replace(/{count}/, count?.toString());
        }
        default: {
            return statusMany.replace(/{count}/, count?.toString());
        }
    }
}
const title = $derived(getStatus($countStore));
</script>

<div class="Status slide-in-from-{slideInFrom}">
  <div class="title" style:--item-number={1}>{title}</div>
</div>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.Status {
  --letter-spacing: var(--text-variant-200-letter-spacing);
  --line-height: var(--text-variant-200-line-height);
  --font-size: var(--text-variant-200-font-size);
  --font-weight: var(--text-variant-200-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-200-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  box-sizing: border-box;
  position: relative;
  letter-spacing: normal;
  color: var(--color-text, var(--color-neutral-000, #000000));
  padding: 10px 0px;
}

.title {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  text-align: left;
}</style>
